<template>
  <div class="form-container adminagency-form-container">
    <h1>行政機関の編集</h1>
    <form>
      <table class="admin-agency-edit-table">
        <tbody>
          <!-- 地域 -->
          <tr>
            <td><label class="required-label">地域</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="editAdmin.region" class="form-control">
                <option value="" disabled>地域を選択してください</option>
                <option 
                  v-for="region in regions" 
                  :key="region.region_id" 
                  :value="region.region_id">
                  {{ region.region_nm }}
                </option>
              </select>
              <span v-if="errors.region" class="error">{{ errors.region }}</span>
            </td>
          </tr>
          <!-- 行政機関ID -->
          <tr>
            <td><label class="required-label">行政機関ID</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.gyouseiId" class="form-control" disabled/>
              <span v-if="errors.gyouseiId" class="error">{{ errors.gyouseiId }}</span>
              <button @click="openModal" class="search-button">行政機関検索</button>
            </td>
          </tr>
          <!-- 行政機関名称 -->
          <tr>
            <td><label class="required-label">行政機関名称</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.gyouseiName" class="form-control" />
              <span v-if="errors.gyouseiName" class="error">{{ errors.gyouseiName }}</span>
            </td>
          </tr>
          <!-- 運用責任者部署 -->
          <tr>
            <td><label>運用責任者部署</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerDepart" class="form-control" />
              <span v-if="errors.managerDepart" class="error">{{ errors.managerDepart }}</span>
            </td>
          </tr>
          <!-- 運用責任者名称 -->
          <tr>
            <td><label>運用責任者名称</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerName" class="form-control" />
              <span v-if="errors.managerName" class="error">{{ errors.managerName }}</span>
            </td>
          </tr>
          <!-- 運用責任者電話番号 -->
          <tr>
            <td><label>運用責任者電話番号</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerTell" class="form-control" />
              <span v-if="errors.managerTell" class="error">{{ errors.managerTell }}</span>
            </td>
          </tr>
          <!-- 運用責任者メールアドレス -->
          <tr>
            <td><label>運用責任者メールアドレス</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.managerMail" class="form-control" />
              <span v-if="errors.managerMail" class="error">{{ errors.managerMail }}</span>
            </td>
          </tr>
          <!-- 行政機関所在地住所 -->
          <tr>
            <td><label>行政機関所在地住所</label></td>
            <td><label>:</label></td>
            <td>
              <input type="text" v-model="editAdmin.gyouseiZyusho" class="form-control" />
              <span v-if="errors.gyouseiZyusho" class="error">{{ errors.gyouseiZyusho }}</span>
            </td>
          </tr>
          <!-- 行政機関区分 -->
          <tr>
            <td><label>行政機関区分</label></td>
            <td><label>:</label></td>
            <td>
              <label>
                <input type="radio" value="国" v-model="editAdmin.gyouseiKbn"/> 国
              </label>
              <label>
                <input type="radio" value="都道府県" v-model="editAdmin.gyouseiKbn"/> 都道府県
              </label>
              <label>
                <input type="radio" value="市区町村" v-model="editAdmin.gyouseiKbn"/> 市区町村
              </label>
              <span v-if="errors.gyouseiKbn" class="error">{{ errors.gyouseiKbn }}</span>
            </td>
          </tr>
          <!-- 契約情報 -->
          <tr>
            <td><label>契約行政機関者ID数</label></td>
            <td><label>:</label></td>
            <td>
              <input type="number" v-model="editAdmin.agencyIdCount" class="form-control" min="0" :disabled="editAdmin.agencyIdStatus === '無効'"/>
              <span v-if="errors.agencyIdCount" class="error">{{ errors.agencyIdCount }}</span>
              <label>
                <input type="radio" value="有効" v-model="editAdmin.agencyIdStatus"/> 有効
              </label>
              <label>
                <input type="radio" value="無効" v-model="editAdmin.agencyIdStatus"/> 無効
              </label>
               <span v-if="errors.agencyIdStatus" class="error">{{ errors.agencyIdStatus }}</span>
            </td>
          </tr>
          <tr>
            <td><label>契約捕獲従事者ID数</label></td>
            <td><label>:</label></td>
            <td>
              <input type="number" v-model="editAdmin.hunterIdCount" class="form-control" min="0" :disabled="editAdmin.hunterIdStatus === '無効'"/>
              <span v-if="errors.hunterIdCount" class="error">{{ errors.hunterIdCount }}</span>
              <label>
                <input type="radio" value="有効" v-model="editAdmin.hunterIdStatus"/> 有効
              </label>
              <label>
                <input type="radio" value="無効" v-model="editAdmin.hunterIdStatus"/> 無効
              </label>
              <span v-if="errors.hunterIdStatus" class="error">{{ errors.hunterIdStatus }}</span>              
            </td>
          </tr>
          <tr>
            <td><label>契約見える化管理者ID数</label></td>
            <td><label>:</label></td>
            <td>
              <input type="number" v-model="editAdmin.mieruAdminCount" class="form-control" min="0" :disabled="editAdmin.mieruAdminStatus === '無効'"/>
              <span v-if="errors.mieruAdminCount" class="error">{{ errors.mieruAdminCount }}</span>
              <label>
                <input type="radio" value="有効" v-model="editAdmin.mieruAdminStatus"/> 有効
              </label>
              <label>
                <input type="radio" value="無効" v-model="editAdmin.mieruAdminStatus"/> 無効
              </label>
              <span v-if="errors.mieruAdminStatus" class="error">{{ errors.mieruAdminStatus }}</span>            
            </td>
          </tr>
          <tr>
            <td><label>契約見える化メンバーID数</label></td>
            <td><label>:</label></td>
            <td>
              <input type="number" v-model="editAdmin.mieruMemberCount" class="form-control" min="0" :disabled="editAdmin.mieruMemberStatus === '無効'"/>
              <span v-if="errors.mieruMemberCount" class="error">{{ errors.mieruMemberCount }}</span>
              <label>
                <input type="radio" value="有効" v-model="editAdmin.mieruMemberStatus"/> 有効
              </label>
              <label>
                <input type="radio" value="無効" v-model="editAdmin.mieruMemberStatus"/> 無効
              </label>
              <span v-if="errors.mieruMemberStatus" class="error">{{ errors.mieruMemberStatus }}</span>
            </td>
          </tr>
        </tbody>
      </table>
  </form>
  <div class="button-container">
      <button type="submit" class="update-button" @click="updateAdminAgency">更新</button>
  </div>
  <!-- 検索モーダル -->
  <SearchModal
    caller="agency" 
    :isVisible="isModalVisible"
    :displayColumns="[
      { key: 'id', label: '行政機関ID' },
      { key: 'name', label: '行政機関名称' }
    ]"
    :title="'行政機関検索'" 
    :categories="[]" 
    :targetData="[]" 
    @close="closeModal"
    @select="handleSelect"
  />

 </div>
</template>

<script>
import "@/assets/styles/AdminAgency.css";
import axios from 'axios'; // axiosをインポート

import SearchModal from '@/components/SearchModal.vue';

export default {
  name: 'AdminAgencyEdit',
  components: {
    SearchModal,
  },
  data() {
    return {
      regions: [],
      editAdmin: {
        region: '',
        gyouseiId: '',
        gyouseiName: '',
        managerDepart: '',
        managerName: '',
        managerTell: '',
        managerMail: '',
        gyouseiKbn: '国',
        gyouseiZyusho: '',
        agencyIdCount: 0,
        agencyIdStatus: '無効',
        hunterIdCount: 0,
        hunterIdStatus: '無効',
        mieruAdminCount: 0,
        mieruAdminStatus: '無効',
        mieruMemberCount: 0,
        mieruMemberStatus: '無効',
        modifierId: '',
      },
      errors: {},
      isModalVisible: false,
      searchData: {
        searchTerm: '', 
        category: 'all',
      },
      modalTitle: '行政機関検索',  // モーダルのタイトル
      selectedResult: null,  // 選択された検索結果
    };
  },
  mounted() {
    this.getRegionDetails();
  },
  methods: {
    isRequired(value) {
       return value !== null && value !== undefined && String(value).trim() !== '';
    },
    isMaxLength(value, maxLength) {
      return value.length <= maxLength;
    },
    isAlphanumeric(value) {
      return /^[a-zA-Z0-9]+$/.test(value);
    },
    isPhoneNumber(value) {
      return /^\d{10,11}$/.test(value);
    },
    isEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length <= 50;
    },
    isTwoDigitRegionID(value) {
      return /^\d{2}$/.test(value);  // 2桁の数字のみを許可
    },
    validateForm() {
      this.errors = {}; // エラーメッセージを初期化
      const fields = [
        {
          key: 'region',
          value: this.editAdmin.region,
          label: '地域',
          isRequired: true,
          maxLength: 2,
          additionalCheck: this.isTwoDigitRegionID,
        },
        {
          key: 'gyouseiId',
          value: this.editAdmin.gyouseiId,
          label: '行政機関ID',
          isRequired: true,
          maxLength: 8,
          additionalCheck: this.isAlphanumeric,
          errorMessage: '行政機関IDは英数字のみで入力してください。',
        },
        {
          key: 'gyouseiName',
          value: this.editAdmin.gyouseiName,
          label: '行政機関名称',
          isRequired: true,
          maxLength: 50
        },
        {
          key: 'managerDepart',
          value: this.editAdmin.managerDepart,
          label: '運用責任者部署',
          maxLength: 20
        },
        {
          key: 'managerName',
          value: this.editAdmin.managerName,
          label: '運用責任者名称',
          maxLength: 20
        },
        {
          key: 'managerTell',
          value: this.editAdmin.managerTell,
          label: '運用責任者電話番号',
          additionalCheck: value => !value || this.isPhoneNumber(value), // 値が空でない場合にのみチェック
          errorMessage: '運用責任者電話番号はハイフンなしで10〜11桁の数字を入力してください。',
        },
        {
          key: 'managerMail',
          value: this.editAdmin.managerMail,
          label: '運用責任者メールアドレス',
          additionalCheck: value => !value || this.isEmail(value), // 値が空でない場合にのみチェック
          errorMessage: '運用責任者メールアドレスは50文字以内で「@」を含む正しい形式で入力してください。',
        },
        {
          key: 'gyouseiZyusho',
          value: this.editAdmin.gyouseiZyusho,
          label: '行政機関所在地住所',
          maxLength: 50
        },
        {
          key: 'agencyIdCount',
          value: this.editAdmin.agencyIdCount,
          label: '契約行政機関者ID数',
          maxLength: 2
        },
        {
          key: 'hunterIdCount',
          value: this.editAdmin.hunterIdCount,
          label: '契約捕獲従事者ID数',
          maxLength: 2
        },
        {
          key: 'mieruAdminCount',
          value: this.editAdmin.mieruAdminCount,
          label: '契約見える化管理者ID数',
          maxLength: 2
        },
        {
          key: 'mieruMemberCount',
          value: this.editAdmin.mieruMemberCount,
          label: '契約見える化メンバーID数',
          maxLength: 2
        },
      ];

      fields.forEach(({ key, value, label, isRequired, maxLength, additionalCheck, errorMessage }) => {
        if (isRequired && !this.isRequired(value)) {
          this.errors[key] = `${label}は必須項目です。`;
        } else if (maxLength && !this.isMaxLength(value, maxLength)) {
          this.errors[key] = `${label}は${maxLength}文字以内で入力してください。`;
        } else if (additionalCheck && !additionalCheck(value)) {
          this.errors[key] = errorMessage;
        }
      });

      return Object.keys(this.errors).length === 0; // エラーがない場合はtrue
    },
    validateAndRegister() {
      if (this.validateForm()) {
        this.register();
      } else {
        // バリデーションエラーがある場合にポップアップで警告を表示
        alert('入力エラーがあります。');
      }
    },
    resetForm() {
      this.editAdmin = {
        region_id: '',
        gyouseiId: '',
        gyouseiName: '',
        gyouseiKbn: '',
        managerDepart: '',
        managerName: '',
        managerTell: '',
        managerMail: '',
        gyouseiKbn: '国',
        gyouseiZyusho: '',
        agencyIdCount: '0',
        agencyIdStatus: '無効',
        hunterIdCount: '0',
        hunterIdStatus: '無効',
        mieruAdminCount: '0',
        mieruAdminStatus: '無効',
        mieruMemberCount: '0',
        mieruMemberStatus: '無効',
        modifierId: '',
      };
    },
    openModal() {
      this.searchData = { keyword: '' }
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleSelect(result) {
      // イベントオブジェクトかどうかを判定
      if (result && result.target) {
        return;
      }

      // 他のフィールドを更新
      this.editAdmin = {
        ...this.editAdmin,
        region: result.region,
        gyouseiId: result.id,
        gyouseiName: result.name || '',
        gyouseiKbn: result.gyouseiKbn === '0' ? '国' : 
                    result.gyouseiKbn === '1' ? '都道府県' : 
                    result.gyouseiKbn === '2' ? '市区町村' : null,
        managerDepart: result.managerDepart || '',
        managerName: result.managerName || '',
        managerTell: result.managerTell || '',
        managerMail: result.managerMail || '',
        gyouseiZyusho: result.gyouseiZyusho || '',
        agencyIdCount: result.agencyIdCount || '',
        agencyIdStatus: result.agencyIdStatus === '1' ? '有効' : '無効',
        hunterIdCount: result.hunterIdCount || '',
        hunterIdStatus: result.hunterIdStatus === '1' ? '有効' : '無効',
        mieruAdminCount: result.mieruAdminCount || '',
        mieruAdminStatus: result.mieruAdminStatus === '1' ? '有効' : '無効',
        mieruMemberCount: result.mieruMemberCount || '',
        mieruMemberStatus: result.mieruMemberStatus === '1' ? '有効' : '無効',
        modifierId: '',
      };
    },
    async getAdminAgency() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得

      if (!token) {
        alert("ログインしていません。再度ログインしてください。");
        return;
      }

      if (!userId) {
        alert("ログイン情報が見つかりません。再度ログインしてください。");
        return;
      }

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/getDetail`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.userInfo = response.data.data; // APIレスポンスデータを userInfo に格納
        } else {
          alert(`データの取得に失敗しました。ステータスコード: ${response.status}`);
        }
      } catch (error) {
        console.error("エラー詳細:", error.response || error.message);
        alert("タイムアウトです。再ログインしてください。");
      }
    },
    async getRegionDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得

      if (!token) {
        alert("ログインしていません。再度ログインしてください。");
        return;
      }

      if (!userId) {
        alert("ログイン情報が見つかりません。再度ログインしてください。");
        return;
      }

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/regionSearch/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.regions = response.data.data;
        } else {
          alert(`データの取得に失敗しました。ステータスコード: ${response.status}`);
        }
      } catch (error) {
        console.error("エラー詳細:", error.response || error.message);
        alert("タイムアウトです。再ログインしてください。");
      }
    },
    async updateAdminAgency() {
      // JWTトークンを取得
      const token = localStorage.getItem("jwtToken");
      if (!token) {
        alert("ログインしていません。再度ログインしてください。");
        return;
      }

      // セッションストレージから userId を取得
      const userId = localStorage.getItem("userId");
      if (!userId) {
        alert("ログイン情報が見つかりません。再度ログインしてください。");
        return;
      }

      try {
        // サーバーに送信するデータ
        const requestData = {
          region_id: this.editAdmin.region,
          id: this.editAdmin.gyouseiId,
          gyouseiName: this.editAdmin.gyouseiName,
          managerDepart: this.editAdmin.managerDepart,
          managerName: this.editAdmin.managerName,
          managerTell: this.editAdmin.managerTell,
          managerMail: this.editAdmin.managerMail,
          gyouseiKbn: this.editAdmin.gyouseiKbn === '国' ? 0 : 
                      this.editAdmin.gyouseiKbn === '都道府県' ? 1 : 
                      this.editAdmin.gyouseiKbn === '市区町村' ? 2 : null,
          gyouseiZyusho: this.editAdmin.gyouseiZyusho,
          agencyIdCount: this.editAdmin.agencyIdCount,
          agencyIdStatus: this.editAdmin.agencyIdStatus === '有効' ? 1 : 0,
          hunterIdCount: this.editAdmin.hunterIdCount,
          hunterIdStatus: this.editAdmin.hunterIdStatus === '有効' ? 1 : 0,
          mieruAdminCount: this.editAdmin.mieruAdminCount,
          mieruAdminStatus: this.editAdmin.mieruAdminStatus === '有効' ? 1 : 0,
          mieruMemberCount: this.editAdmin.mieruMemberCount,
          mieruMemberStatus: this.editAdmin.mieruMemberStatus === '有効' ? 1 : 0,
          modifierId: userId,
        };

        // APIリクエスト送信
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/update`,
          requestData,
          {
            headers: {           
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );

        // ステータスコード200の場合（送信成功）
        if (response.status === 200) {
          alert("データが正常に登録されました。");
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          // 必要に応じてフォームのリセットや画面遷移を実行
          this.resetForm();          
        }
      } catch (error) {
        // エラーハンドリング
        if (error.response && error.response.status === 400) {
          alert(error.response.data.message || "リクエストにエラーがあります。");
        } else if (error.response && error.response.status === 401) {
          alert("認証エラー: ログイン情報を確認してください。");
        } else if (error.response && error.response.status === 500) {
          alert("サーバーエラーが発生しました。しばらくしてからお試しください。");
        } else {
          alert("ネットワークエラーが発生しました。接続を確認してください。");
        }
        console.error("送信エラー:", error);
      }
    },
  },
};
</script>

<style scoped>
</style>
